import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
  apiKey: 'AIzaSyAhv8Wvt-r79NHVdKUR4N0iZphIWafQao4',
  authDomain: 'bd-biblio.firebaseapp.com',
  databaseURL: 'https://bd-biblio.firebaseio.com',
  projectId: 'bd-biblio',
  storageBucket: 'bd-biblio.appspot.com',
  messagingSenderId: '754386650309',
  appId: '1:754386650309:web:8c21973d508a6139e69cac',
  measurementId: 'G-FQRWHL6HCP'
}
firebase.initializeApp(config)

// Get a reference to the database service
export const db = firebase.firestore()
export const auth = firebase.auth()
